<div class="relative">
  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

  <button
    mat-button
    color="accent"
    ixTest="export"
    [disabled]="isLoading"
    (click)="onExport()"
  >
    {{ 'Export As {fileType}' | translate:{ fileType: fileType.toUpperCase()} }}
  </button>
</div>
